import React from "react"
import Spin from "@infotech/uikit-spin"
import { LoaderIcon } from "@infotech/uikit-icons"
import FormBox from "src/components/forms/fragments/FormBox"

export default function LoaderBox({ size, color }) {
  return (
    <FormBox>
      <Spin duration="fast">
        <LoaderIcon size={size || `medium`} color={color} />
      </Spin>
    </FormBox>
  )
}
